export default "__VITE_ASSET__09048c4b__"